import $ from 'jquery';
import Backbone from 'backbone';
import template from '../templates/sticky.html';
import env from '../environments/index';

const NoticesStickyView = Backbone.View.extend({
  events: {
    'click #notice-sticky-container': 'open',
  },

  initialize(options) {
    this.options = options || {};
  },

  render() {
    this.$el.append(template(this.options.noticeData));
    $('#notice-sticky-container').show();
    const { id } = this.options.noticeData;
    const { cookie, domain } = env;
    // eslint-disable-next-line no-undef
    document.cookie = `${cookie}${id}=true; Max-Age=86400; path=/;Domain=${domain}; samesite=None; Secure;`;
  },

  open() {
    this.deleteCookie();
    if (this.options.openCallback) {
      this.options.openCallback();
      this.hide();
    }
  },

  hide() {
    $('#notice-sticky-container').hide();
  },

  deleteCookie() {
    const { id } = this.options.noticeData;
    const { cookie, domain } = env;
    // eslint-disable-next-line no-undef
    document.cookie = `${cookie}${id}=; path=/;Domain=${domain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT; samesite=None; Secure;`;
  },

  close() {
    this.hide();
    this.$el.empty().off();
  },
});

export default NoticesStickyView;



/** WEBPACK FOOTER **
 ** ./src/views/sticky.js
 **/